export const MEDIA_TYPES = {
    PDF: "application/pdf",
    IMAGE_GIF: "image/gif",
    IMAGE_JPEG: "image/jpeg",
    IMAGE_JPG: "image/jpg",
    IMAGE_PNG: "image/png",
};
export const SUPPORTED_MEDIA_TYPE_IMAGES = [
    MEDIA_TYPES.IMAGE_JPEG,
    MEDIA_TYPES.IMAGE_JPG,
    MEDIA_TYPES.IMAGE_PNG,
    MEDIA_TYPES.IMAGE_GIF,
];
export const imageOfSupportedMimeType = (file) => file.type && SUPPORTED_MEDIA_TYPE_IMAGES.indexOf(file.type) > -1;
export const readFilesAsBase64 = (files) => {
    const promises = files.map(file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    }));
    return Promise.all(promises);
};
